<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"></slot>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Downloads
      </v-card-title>
      <v-card-text class="px-0">
        <v-tabs
          v-model="tab"
          grow
        >
          <v-tab
            key="analises"
          >
            Analises
          </v-tab>
          <v-tabs-items v-model="tab" class="px-2">
            <v-tab-item
              key="analises"
            >
              <empty-state
                v-if="isLoading"
                color="accent"
              >
                <template v-slot:icon>
                  <v-icon class="spinning" color="accent">mdi-sync</v-icon>
                </template>
                <template v-slot:description>
                  Carregando...
                </template>
              </empty-state>
              <empty-state
                v-else-if="resultIsEmpty"
              >
                <template v-slot:icon>
                  <v-icon>mdi-folder-open</v-icon>
                </template>
                <template v-slot:description>
                  Nenhum relatório encontrado
                </template>
              </empty-state>
              <v-list
                v-else
                rounded
              >
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, idx) in results"
                    :key="idx"
                    :href="item['urls'][0]"
                    target="_blank"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item["name"]}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {isEmpty} from "lodash/lang"
  import EmptyState from "../../../Helpers/EmptyState"
  import {listFieldsPostProcessingAnalysisResults} from "../../../../api/api-project"

  export default {
    name: "PostProcessingResultAnalysisDownloads",
    components: {EmptyState},
    props: {
      idFieldPostProcessing: {
        type: Number,
        required: true
      },
      analysisType: {
        type: String,
        required: true
      }
    },
    data: () => ({
      tab: null,
      active: false,
      isLoading: false,
      results: []
    }),
    methods: {
      onOpen() {
        this.isLoading = true

        const authToken = this.$apiAuth.getAuthToken()
        listFieldsPostProcessingAnalysisResults(authToken, this.idFieldPostProcessing, this.analysisType)
          .then((res) => {
            this.results = res.data.data["results"]
          })
          .finally(() => {
            this.isLoading = false
          })
      },
    },
    computed: {
      resultIsEmpty() {
        if (!this.results) return true
        return isEmpty(this.results)
      },
    },
     watch: {
      active(newValue) {
        if (newValue) this.onOpen()
      },
    },
  }
</script>

<style scoped>

</style>
